import Vue from 'vue'
import Vuex from 'vuex'

import * as accessAuthority from './modules/accessAuthority'
import * as accessToken from './modules/accessToken'
import * as activityLog from './modules/activityLog'
import * as admin from './modules/admin'
import * as announcement from './modules/announcement'
import * as area from './modules/area'
import * as authentication from './modules/authentication'
import * as card from './modules/card'
import * as company from './modules/company'
import * as download from './modules/download'
import * as duty from './modules/duty'
import * as employee from './modules/employee'
import * as employeeLevel from './modules/employeeLevel'
import * as employeePolicy from './modules/employeePolicy'
import * as employeesGroup from './modules/employeesGroup'
import * as employeeType from './modules/employeeType'
import * as feature from './modules/feature'
import * as firmware from './modules/firmware'
import * as gender from './modules/gender'
import * as googleMap from './modules/googleMap'
import * as hardware from './modules/hardware'
import * as hardwaresGroup from './modules/hardwaresGroup'
import * as holiday from './modules/holiday'
import * as leaveApprover from './modules/leaveApprover'
import * as leaveFile from './modules/leaveFile'
import * as leaveType from './modules/leaveType'
import * as location from './modules/location'
import * as lockUnlock from './modules/lockUnlock'
import * as microsoftEntraId from './modules/microsoftEntraId'
import * as offSiteLocation from './modules/offSiteLocation'
import * as organization from './modules/organization'
import * as password from './modules/password'
import * as position from './modules/position'
import * as prefix from './modules/prefix'
import * as report from './modules/report'
import * as rightsGroup from './modules/rightsGroup'
import * as role from './modules/role'
import * as shift from './modules/shift'
import * as taEmployeesGroup from './modules/taEmployeesGroup'
import * as taHardwaresGroup from './modules/taHardwaresGroup'
import * as taRightsGroup from './modules/taRightsGroup'
import * as timeAttendanceOffSiteGrant from './modules/timeAttendanceOffSiteGrant'
import * as timezone from './modules/timezone'
import * as upload from './modules/upload'
import * as userRole from './modules/userRole'
import * as webhook from './modules/webhook'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: true,
    breadcrumbs: [],
    snackbar: {
      show: false,
      color: 'info',
      timeout: 2000,
      message: 'Message For User',
    },
    loading: false,
    uiCtrl: null,
  },
  mutations: {
    SET_DRAWER(state, drawer) {
      state.drawer = drawer
    },
    SET_BREADCRUMBS(state, breadcrumbs) {
      state.breadcrumbs = breadcrumbs
    },
    SET_SNACKBAR(state, snackbar) {
      state.snackbar = snackbar
    },
    SET_UI_CTRL(state, uiCtrl) {
      state.uiCtrl = uiCtrl
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
  },
  actions: {},
  modules: {
    authentication,
    position,
    employeeType,
    shift,
    organization,
    location,
    employee,
    admin,
    role,
    company,
    accessToken,
    download,
    upload,
    prefix,
    gender,
    timeAttendanceOffSiteGrant,
    offSiteLocation,
    googleMap,
    duty,
    hardware,
    card,
    feature,
    holiday,
    taRightsGroup,
    taHardwaresGroup,
    taEmployeesGroup,
    rightsGroup,
    hardwaresGroup,
    employeesGroup,
    timezone,
    area,
    employeeLevel,
    report,
    lockUnlock,
    userRole,
    employeePolicy,
    activityLog,
    firmware,
    leaveType,
    leaveApprover,
    leaveFile,
    password,
    announcement,
    accessAuthority,
    webhook,
    microsoftEntraId,
  },
})
